import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import styles from "./partners.module.css";

function DetailsTable({ canvasData }) {
  const [activeKeys, setActiveKeys] = useState(["0"]);

  if (!canvasData || !Object.keys(canvasData).length) {
    return <p>No details available</p>;
  }

  const { partnerBasic, partnerTheme, partnerConfig } = canvasData;

  const handleToggle = (key) => {
    setActiveKeys((prevKeys) =>
      prevKeys.includes(key)
        ? prevKeys.filter((k) => k !== key)
        : [...prevKeys, key]
    );
  };

  const groupedConfig = partnerConfig.reduce((acc, config) => {
    const category = config.category || "Others";
    if (!acc[category]) acc[category] = [];
    acc[category].push(config);
    return acc;
  }, {});

  const formatHost = (host) => {
    if (!host) return "";
    return host.startsWith("http://") || host.startsWith("https://")
      ? host
      : `https://${host}`;
  };

  const isUrl = (value) => {
    try {
      return Boolean(new URL(value));
    } catch {
      return false;
    }
  };
  const formatConfigValue = (value) => {
    if (value === null || value === undefined) return "--";

    if (typeof value === "boolean") return value ? "True" : "False";

    if (
      Array.isArray(value) &&
      value.every((v) => typeof v === "object" && v !== null)
    ) {
      return (
        <div style={{ overflowX: "auto", maxWidth: "100%" }}>
          <table className={styles.jsonTable}>
            <thead>
              <tr>
                <th className={styles.jsonData}>Label</th>
                <th className={styles.jsonData}>Value</th>
                <th className={styles.jsonData}>Alt</th>
              </tr>
            </thead>
            <tbody>
              {value.map((item, i) => (
                <tr key={i}>
                  <td className={styles.jsonDataValues}>
                    {item.label || "--"}
                  </td>
                  <td className={styles.jsonDataValues}>
                    {item.value || "--"}
                  </td>
                  <td className={styles.jsonDataValues}>{item.alt || "--"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    if (Array.isArray(value)) {
      return value.join(", ");
    }

    if (typeof value === "string") {
      try {
        const cleaned = value
          .replace(/^{|}$/g, "")
          .replace(/\\/g, "")
          .replace(/"+/g, "")
          .trim();

        return cleaned
          .split(",")
          .map((s) => s.trim())
          .join(", ");
      } catch {
        return value;
      }
    }

    return value.toString();
  };
  const apiConfigurationDetail = (apiConfig) => {
    if (!apiConfig) return null;

    return (
      <tr>
        <td colSpan="2">
          <h5 style={{ marginTop: "1rem", marginBottom: "0.5rem" }}>
            API Configuration
          </h5>
          <table className={styles.detailsTable} style={{ marginLeft: "1rem" }}>
            <tbody>
              <tr>
                <td>API Key:</td>
                <td className={styles.textMuted}>{apiConfig.apiKey || "--"}</td>
              </tr>
              <tr>
                <td>Access Key:</td>
                <td className={styles.textMuted}>
                  {apiConfig.accessKey || "--"}
                </td>
              </tr>
              <tr>
                <td>Client Type:</td>
                <td className={styles.textMuted}>
                  {apiConfig.clientType || "--"}
                </td>
              </tr>
              <tr>
                <td>Scopes:</td>
                <td className={styles.textMuted}>
                  {Array.isArray(apiConfig.scopes)
                    ? apiConfig.scopes.join(", ")
                    : "--"}
                </td>
              </tr>
              <tr>
                <td>Plan ID:</td>
                <td className={styles.textMuted}>{apiConfig.id || "--"}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  return (
    <Accordion activeKey={activeKeys} className={styles.accordionContainer}>
      <Accordion.Item eventKey="0">
        <Accordion.Header
          onClick={() => handleToggle("0")}
          className={styles.accordionHeader}
        >
          Basic Information
        </Accordion.Header>
        <Accordion.Body className={styles.accordionBody}>
          <table className={styles.detailsTable}>
            <tbody>
              <tr>
                <td>Partner Name:</td>
                <td className={styles.textMuted}>
                  {partnerBasic?.name || "--"}
                </td>
              </tr>
              <tr>
                <td>Partner Code:</td>
                <td className={styles.textMuted}>
                  {partnerBasic?.code || "--"}
                </td>
              </tr>
              <tr>
                <td>Partner type:</td>
                <td className={styles.textMuted}>
                  {Array.isArray(partnerBasic?.type) &&
                  partnerBasic.type.length > 0
                    ? partnerBasic.type.join(", ")
                    : "--"}
                </td>
              </tr>
              <tr>
                <td>Host:</td>
                <td className={styles.textMuted}>
                  {partnerBasic?.host ? (
                    <a
                      href={formatHost(partnerBasic.host)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.link}
                    >
                       {formatHost(partnerBasic.host)}
                    </a>
                  ) : (
                    "--"
                  )}
                </td>
              </tr>
              <tr>
                <td>Location:</td>
                <td className={styles.textMuted}>
                  {partnerBasic?.location || "--"}
                </td>
              </tr>
              <tr>
                <td>Status:</td>
                <td className={styles.textMuted}>
                  {partnerBasic?.status || "--"}
                </td>
              </tr>
              <tr>
                <td>Created By:</td>
                <td className={styles.textMuted}>
                  {partnerBasic?.createdBy || "--"}
                </td>
              </tr>
              <tr>
                <td>Description:</td>
                <td className={styles.textMuted}>
                  {partnerBasic?.description || "--"}
                </td>
              </tr>
              <tr>
                <td>Logo URL:</td>
                <td className={styles.textMuted}>
                  {partnerBasic?.logo ? (
                    <a
                      href={partnerBasic.logo}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.link}
                    >
                      {partnerBasic.logo}
                    </a>
                  ) : (
                    "--"
                  )}
                </td>
              </tr>
              {partnerBasic?.type?.includes("api") &&
                apiConfigurationDetail(partnerBasic.apiConfiguration)}
            </tbody>
          </table>
        </Accordion.Body>
      </Accordion.Item>

      {partnerTheme && partnerTheme.length > 0 && (
        <Accordion.Item eventKey="2" style={{ marginTop: "20px" }}>
          <Accordion.Header
            onClick={() => handleToggle("2")}
            className={styles.accordionHeader}
          >
            Theme Settings
          </Accordion.Header>
          <Accordion.Body className={styles.accordionBody}>
            <table className={styles.detailsTable}>
              <tbody>
                {partnerTheme.map((theme, index) => (
                  <tr key={`theme-${index}`}>
                    <td>{theme.displayName || theme.key}:</td>
                    <td className={styles.textMuted}>
                      {theme.value ? (
                        isUrl(theme.value) ? (
                          <a
                            href={theme.value}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.link}
                          >
                            {theme.value}
                          </a>
                        ) : (
                          theme.value
                        )
                      ) : (
                        "--"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Accordion.Body>
        </Accordion.Item>
      )}

      {partnerConfig && partnerConfig.length > 0 && (
        <Accordion.Item eventKey="3" style={{ marginTop: "20px" }}>
          <Accordion.Header
            onClick={() => handleToggle("3")}
            className={styles.accordionHeader}
          >
            Configuration Settings
          </Accordion.Header>
          <Accordion.Body className={styles.accordionBody}>
            {Object.entries(groupedConfig).map(([category, configs]) => (
              <div key={category} style={{ marginBottom: "2rem" }}>
                <h4 className={styles.categoryHeading}>
                  {category.charAt(0).toUpperCase() + category.slice(1)}
                </h4>
                <table className={styles.detailsTable}>
                  <tbody>
                    {configs.map((config, index) => (
                      <tr key={`config-${category}-${index}`}>
                        <td>{config.key}:</td>
                        <td className={styles.textMuted} colSpan={2}>
                          {isUrl(config.value?.toString?.()) ? (
                            <a
                              href={config.value}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={styles.link}
                            >
                              {config.value}
                            </a>
                          ) : (
                            formatConfigValue(config.value)
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </Accordion.Body>
        </Accordion.Item>
      )}
    </Accordion>
  );
}

export default DetailsTable;